<div class="row testscores">
    <div class="col-md-12">
        <form
            name="score-report-options-form"
            [formGroup]="userForm"
        >
            <div class="form-container">
                <div class="fadeInDiv">
                    <p
                        *ngIf="isWebDelivery == true && brandName === 'CELPIP' "
                        class="warning py-4"
                    >
                        Please note that scores for the {{brandName}} taken at a Test Centre or Online are used the same way and that the test format, test content, scoring criteria, and rating scale, are exactly the same.
                        While we will send {{brandName}} scores for either delivery method to the institutions you select, we encourage you to confirm that your institution accepts or will accept {{brandName}} Online scores.
                        For more information on institutions that have confirmed {{brandName}} Online acceptance, please see this
                        <a
                            href="{{celpipcoreUsersUrl}}"
                            target="_blank"
                        >link</a>.
                    </p>
                    <br />
                    <div *ngFor="let institution of institutions;let i = index">
                        <div class="receiving-institution-list mb-2">
                            <h5 class="mb-4">Institution
                                {{i + 1}} <a
                                    *ngIf="!(institution?.isRegularMail || institution?.priorityShipping)"
                                    class="pull-right"
                                    style="font-weight: normal"
                                    (click)="removeInstitution(institution)"
                                ><i class="fa fa-remove"></i> Remove</a></h5>
                            <p>Country: {{institution?.country?.name}}</p>
                            <p *ngIf="brandId === BrandEnum.CAEL">Student Number: {{institution?.studentNumber}}</p>
                            <p *ngIf="brandId === BrandEnum.CAEL">Level Applying For: {{institution?.academicLevel}}</p>
                            <p>Institution: {{institution?.institutionName}}</p>
                            <div *ngIf="brandId === BrandEnum.CAEL">
                                <app-order-hardcopy-score-service-cael
                                    *ngIf="!regInProgress && institution"
                                    [institution]="institution"
                                    [regId]="regInfo.regId"
                                    (priorityShippingSubmit)="shippingPreferenceHandler($event)"
                                >
                                </app-order-hardcopy-score-service-cael>
                            </div>
                        </div>
                    </div>
                    <br />
                    <div>
                        <app-score-preferences-institution
                            (institutionSubmit)="institutionSubmitHandler(newScoreRecipientReg)"
                            [submitted]="submitted"
                            [testTypeId]="testTypeId"
                            [countries]="countries"
                            [scoreRecipientReg]="newScoreRecipientReg"
                            [isWebDelivery]="isWebDelivery"
                            [showIRCCOnNewInstitutions]="showIRCCOnNewInstitutions"
                            [regInfo]="regInfo"
                        ></app-score-preferences-institution>
                    </div>
                    <br />
                    <div *ngIf="brandId === BrandEnum.CAEL && !regInProgress">Please note, that the order cannot be cancelled once the score report is shipped from our office.</div>
                    <br />
                    <label *ngIf="brandId === BrandEnum.CAEL && !regInProgress">Total Amount: {{ totalAmount | currency : currencyCode : currencyCode + " "}}</label>
                </div>
            </div>
        </form>
    </div>
</div>

<app-modal
    #confirmRemoveModal
    title="Remove"
    body="Remove this institution?"
    isConfirm="true"
>
</app-modal>
